import { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCustomNavigate } from '../../../hooks/useCustomNavigate';
import { ROUTES } from '../../../types/routes';
import { CustomButton } from '../../common/buttons/index';
import { CustomInput } from '../../common/inputs';
import { useSubmitPhoneVerifyMutation } from '../../../data/mutations/registration';
import { ParamContext } from '../../../data/param.provider';

const RegistrationPhoneLayout = () => {
	const { t } = useTranslation();
	const navigate = useCustomNavigate();

	const { wState } = useContext(ParamContext);

	const [phone, setPhone] = useState<string>('');
	const [isPhoneRequired, setIsPhoneRequired] = useState<boolean>(false);

	const [phoneErrorFake, setPhoneErrorFake] = useState<boolean>(false);

	const { mutateAsync, mutationError, isError, isPending } =
		useSubmitPhoneVerifyMutation(navigate);

	useEffect(() => {
		const wStateInfo = JSON.parse(
			sessionStorage.getItem('wStateInfo') as string
		);
		if (wStateInfo) {
			setPhone(wStateInfo.initMobile?.replace('+', ''));
			setIsPhoneRequired(
				wStateInfo.initMobile?.length > 0
			);
		}
	}, []);

	useEffect(() => {
		if (isError) {
			setPhoneErrorFake(isError);
		}
	}, [isError]);

	const buttonRef = useRef(null);

	const handlePhoneChange = (
		e: string | React.ChangeEvent<HTMLInputElement>
	) => {
		if (typeof e === 'string') {
			setPhoneErrorFake(false);
			setPhone(e as string);
			setIsPhoneRequired(String(e)?.length > 0);
		}
	};

	const handlePhoneClear = () => {
		setPhone('');
		setIsPhoneRequired(false);
	};

	const handleBackClick = () => {
		navigate(ROUTES.REGISTRATION.INDEX);
	};

	const handleSubmit = () => {
		mutateAsync({
			phone: '+' + phone.replaceAll(' ', ''),
			isPhoneVerified: false,
			wState: wState
		});
		sessionStorage.setItem('phone', '+' + phone.replaceAll(' ', ''));
	};

	return (
		<div className={'component'}>
			<div className={'innerComponent'}>
				<CustomButton
					isBack={true}
					onClick={handleBackClick}
					className={'backButton'}
				/>
				<h1 className={'confirmEmailText'}>
					{t('registrationMobilePhone')}
				</h1>
				<h1 className={'confirmCodeText'}>
					{t('registrationProvideMobile')}
				</h1>
				<div className={'mobileInputBlock'}>
					<CustomInput
						isError={phoneErrorFake}
						isDisabled={false}
						isRequired={isPhoneRequired}
						type={'text'}
						id={'number'}
						label={t('registrationPhone')}
						value={phone}
						onChange={handlePhoneChange}
						className={'phoneInput'}
						onClearClick={handlePhoneClear}
						placeHolder={'000000000000'}
						isMobile={true}
						inputPropsRef={buttonRef}
					/>
				</div>
				{phoneErrorFake ? (
					<h1 className={'registrationEmailError'}>
						{
							(mutationError as any)?.message //eslint-disable-line @typescript-eslint/no-explicit-any
						}
					</h1>
				) : (
					<div className={'registrationEmailError'} />
				)}
				<CustomButton
					buttonRef={buttonRef}
					text={t('registrationStart') as string}
					type={'submit'}
					onClick={handleSubmit}
					className={'startButton'}
					isDisabled={phone?.length < 6}
					isLoading={isPending}
				/>
			</div>
		</div>
	);
};

export default RegistrationPhoneLayout;
